module.exports = __webpack_public_path__ + "static/media/card.2a2c26ca.png";